export const CALENDAR_LINK = 'https://calendly.com/hamnjam/40min?month=2023-02'
export const PAGE_NEWS_COUNT = 6
export const PAGE_GET_COUNT = 10
export const SHARE_URL = 'http://nikita.4steps.am/hy/blog'